module.exports = __webpack_public_path__ + "img/bgtop5.1444d620.jpg";